import { ControllerProps } from 'strikejs-react';
import {Translation, INIT_TRANSLATIONS, ImagesData,ProtanopiaData, DeuteranopiaData, TritanopiaData  } from '../../models/models';
import { DataService } from '../../services/DataService';
import { Dictionary } from 'lodash';

// export const STATE_KEY = 'app';

export interface ContentManagerProps extends ControllerProps<ContentManagerState> {
	dataService:DataService;
}

export interface ContentManagerState{
	locale:Translation;
	data:ImagesData[];
	protanopia:ProtanopiaData[];
	deuteranopia:DeuteranopiaData[];
	tritanopia:TritanopiaData[];
        

}

export const ContentManagerInitState:ContentManagerState = {
	locale: INIT_TRANSLATIONS,
	data:[],
	protanopia:[],
	deuteranopia:[],
	tritanopia:[],
}

export interface inContentManagerState{
	
}

export const inContentManagerInitialState:inContentManagerState = {

}



// WEBPACK FOOTER //
// ./src/controllers/ContentManager/StateAndProps.ts